import React, { useState, useEffect, useRef } from "react";
import TableWrapper from "../../components/table/reactTable";
import styled from "styled-components";
import ContentHeader from "../../components/header/contentHeader";
import { useParams } from "react-router";
import DB from "../../DB/firebase";
import { InputWrapper } from "../../components/input";
import {
  Row,
  Col,
  Modal,
  Form,
  message,
  Button,
  Upload,
  Image,
  Tabs,
  Table,
  Input,
} from "antd";
import { TableButton, AddButton } from "../../components/buttons";

import { Link } from "react-router-dom";
import { useForm } from "antd/lib/form/Form";
import Column from "antd/lib/table/Column";
import { deleteDataById, getDataById, addOrUpdateData } from "../../apis/generalApis";

const StyledContent = styled.div`
  .form-label {
    text-align: left;
    margin-bottom: 8px;
    font-size: 16px;
  }
`;

const SubServices = () => {
  let params = useParams();
  const { id, category } = useParams();
  const [subServicesData, setSubServicesData] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const [subServiceModal, setSubServiceModal] = useState(false);
  const [subServiceForm] = useForm();
  const [imageLoader, setImageLoader] = useState(false);
  const [modalType, setModalType] = useState("ADD");
  const [currentIndex, setCurrentIndex] = useState(0);

  const [currentSubService, setCurrentSubService] = useState({
    subServiceTitle: "",
    subServiceType: "",
    icon: "",
    id: "",
  });

  const handleChangeSubService = (event) => {
    const { name, value } = event.target;
    setCurrentSubService({ ...currentSubService, [name]: value });
  };

  useEffect(() => {
    getServicesByServiceId();
  }, []);

  const getServicesByServiceId = async () => {
    let subServicesData;
    if (params && params.id) {
      let body = {
        service_id: params.id,
      };
      subServicesData = await getDataById("show-sub-services-by-services", body);
      setSubServicesData(subServicesData);
    }
  };

  const handleSubServiceForm = async (values) => {
    if (currentSubService.subServiceTitle === "" || currentSubService.icon === "") {
      message.error("1 or more fields missing");
    } else {
      debugger;
      const headers = { "Content-Type": "multipart/form-data" };
      const formData = new FormData();
      formData.append("service_id", params?.id);
      formData.append("title", currentSubService.subServiceTitle);
      let result;
      if (modalType === "EDIT") {
        if (typeof currentSubService.icon != "string") {
          formData.append("icon", currentSubService.icon);
        }
        formData.append("subservice_id", currentSubService.id);
        result = await addOrUpdateData("update-sub-service", formData, headers);
      } else if (modalType === "ADD") {
        formData.append("icon", currentSubService.icon);
        result = await addOrUpdateData("add-sub-service", formData, headers);
      }
      if (result != null) {
        let successMessage =
          modalType === "EDIT"
            ? "Sub service updated successfully!"
            : "Sub service added successfully!";
        setSubServiceModal(false);
        message.success(successMessage);
        getServicesByServiceId();
      } else {
        message.error("Something went wrong!");
      }
    }
  };

  const handleDelete = async (subservice_id) => {
    try {
      let body = {
        subservice_id,
      };
      let response = await deleteDataById("delete-sub-service", body);
      if (response.success === true) {
        message.success("Deleted Successfully");
        getServicesByServiceId();
      } else {
        message.error("Something went wrong");
      }
    } catch (error) {
      message.error(error);
    }
  };

  return (
    <>
      <div>
        <ContentHeader title={`SUB SERVICES`} />
        <AddButton
          onClick={() => {
            setModalType("ADD");
            setSubServiceModal(true);
            setCurrentSubService({
              subServiceTitle: "",
              subServiceType: "",
              icon: "",
            });
          }}
          style={{ float: "right", margin: "12px 0" }}
        >
          + Add New
        </AddButton>
        <Modal
          title={`${modalType === "EDIT" ? "Edit" : "Add"} Service Modal`}
          visible={subServiceModal}
          onCancel={() => {
            setSubServiceModal(false);
          }}
          footer={null}
          centered
        >
          <StyledContent>
            <Form
              form={subServiceForm}
              id="Service"
              onFinish={handleSubServiceForm}
              validateTrigger="onFinish"
              initialValues={{ subServiceTitle: currentSubService.subServiceTitle }}
            >
              <Row justify="space-between">
                <Col span={11}>
                  <h4 className="form-label">*sub service Title</h4>
                  <Form.Item
                    name="subServiceTitle"
                    rules={[
                      {
                        required: true,
                        max: 20,
                        message: "Sub Service Title is required",
                      },
                    ]}
                  >
                    <p style={{ display: "none" }}>
                      {console.log(currentSubService.subServiceTitle)}
                    </p>
                    <Input
                      maxLength={20}
                      name="subServiceTitle"
                      value={currentSubService.subServiceTitle}
                      placeholder="Service Name"
                      onChange={handleChangeSubService}
                    />
                  </Form.Item>
                </Col>
                {/* <Col span={11}>
                  <h4 className="form-label">{"Service Type"} </h4>

                  <Form.Item name="serviceType" rules={[{ required: true, max: 20 }]}>
                    <InputWrapper
                      maxLength={20}
                      name="subServiceType"
                      value={currentSubService.subServiceType}
                      placeholder="Service Name"
                      onChange={handleChangeSubService}
                    />
                  </Form.Item>
                </Col> */}
                <Col span={11}>
                  <h4 className="form-label">*Image</h4>
                  {imageLoader == true ? (
                    <h4>Loading...</h4>
                  ) : (
                    <Image width={200} src={currentSubService.icon} preview={false} />
                  )}
                  <h4 className="form-label">Edit image</h4>
                  <input
                    type="file"
                    id="files"
                    placeholder="Edit image"
                    title="choose image"
                    required={currentSubService.icon === ""}
                    name="myfile"
                    onChange={async (event) => {
                      if (event.target.files[0]) {
                        debugger;
                        setCurrentSubService({
                          ...currentSubService,
                          icon: event.target.files[0],
                        });
                      } else {
                        setCurrentSubService({ ...currentSubService, icon: "" });
                      }
                    }}
                  />
                </Col>
              </Row>

              <Row justify="end" align="middle" style={{ marginTop: "1rem" }}>
                <Col span={7} style={{ paddingLeft: "10px" }}>
                  <Button
                    block
                    shape="round"
                    type="danger"
                    size="default"
                    onClick={() => {
                      setSubServiceModal(false);
                    }}
                  >
                    Cancel
                  </Button>
                </Col>
                <Col span={7} style={{ paddingLeft: "10px" }}>
                  <Button
                    block
                    shape="round"
                    type="primary"
                    size="default"
                    style={{
                      outline: "none",
                      border: "none",
                      backgroundColor: "#49D3CE",
                    }}
                    htmlType="submit"
                  >
                    {"Ok"}
                  </Button>
                </Col>
              </Row>
            </Form>
          </StyledContent>
        </Modal>

        <Table dataSource={subServicesData}>
          <Column title="Name" dataIndex="title" key="title" />
          <Column
            title="Service Type"
            dataIndex="service.name"
            key="service.name"
            render={(record) => (
              <>
                <p>
                  {record?.service?.name}
                  {record?.service && record?.service?.is_feature === true
                    ? " Featured"
                    : " Regular"}
                </p>
              </>
            )}
          />
          <Column
            title="Action"
            render={(service) => (
              <>
                <Button
                  type="primary"
                  style={{ marginRight: "10px" }}
                  onClick={() => {
                    setCurrentSubService({
                      ...currentSubService,
                      subServiceTitle: service?.title,
                      icon: service.image,
                      id: service.id,
                    });
                    setModalType("EDIT");
                    setSubServiceModal(true);
                  }}
                >
                  EDIT
                </Button>
                <Button type="danger" onClick={() => handleDelete(service?.id)}>
                  DELETE
                </Button>
              </>
            )}
          />
        </Table>
        {/* <TableWrapper
          tableData={subServicesData}
          showPagination={true}
          columns={[
            {
              Header: "Title",
              accessor: "name",
              sortable: false,
              Cell: (r) => {
                return <p>{r.original.title}</p>;
              },
            },
            {
              Header: "Service Type",
              accessor: "name",
              sortable: false,
              Cell: (r) => {
                console.log("r", r);
                return <p>{r.original.serviceType}</p>;
              },
            },
            {
              Header: "Action",
              accessor: "name",
              sortable: false,
              Cell: (r) => {
                return (
                  <>
                    <Link to={`/price/${id}/${category}/${r.index}`}>
                      <Button type="">VIEW PRICES</Button>
                    </Link>

                    <Button
                      type="primary"
                      onClick={() => {
                        setModalType("EDIT");
                        setSubServiceModal(true);
                        setCurrentSubService({
                          ...currentSubService,
                          subServiceTitle: r?.original?.title,
                          subServiceType: r?.original?.serviceType,
                          icon: r?.original?.icon,
                          prices: r?.original?.Price,
                        });
                        subServiceForm.setFieldsValue({
                          subServiceTitle: r?.original?.title,
                          serviceType: r?.original?.serviceType,
                        });

                        setCurrentIndex(r?.index);

                        // console.log("r",r.original)
                      }}
                    >
                      EDIT
                    </Button>
                    <Button
                      type="danger"
                      onClick={() => {
                        handleDelete(r.index);
                      }}
                    >
                      DELETE
                    </Button>
                  </>
                );
              },
            },
          ]}
        /> */}
      </div>
    </>
  );
};

export default SubServices;

const StyledActionContent = styled.div`
  p {
    color: #1d194d;
    cursor: pointer;
    margin: 4px 0;
    :hover {
      text-decoration: underline;
      color: #393385;
    }
  }
`;
